import { UserEntity } from '../interfaces';

export function getUserInitials(user: UserEntity): string {
  if (!user?.name) {
    return '';
  }
  const initials = user.name.match(/\b\w/g) || [];
  return `${initials.shift() || ''}${initials.pop() || ''}`.toUpperCase();
}
